"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._execute_flingDisc = exports.execute = exports.forwardToAll = exports.requestHost = exports.create = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EMinigolfInputHint = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageMessageIds_1 = require("@voyage/multi/voyageMessageIds");
var minigolf_bufferedCommands_sidecar_1 = require("../simulation/minigolf_bufferedCommands-sidecar");
var minigolfMainGameGenerator_sidecar_1 = require("../simulation/minigolfMainGameGenerator-sidecar");
var minigolfCreatures_sidecar_1 = require("../entities/minigolfCreatures-sidecar");
var namespace = 'minigolf-message-input';
var EMinigolfInputHint;
(function (EMinigolfInputHint) {
    EMinigolfInputHint[EMinigolfInputHint["Null"] = 0] = "Null";
    EMinigolfInputHint[EMinigolfInputHint["PlaceDisc"] = 1] = "PlaceDisc";
    EMinigolfInputHint[EMinigolfInputHint["FlingDisc"] = 2] = "FlingDisc";
    EMinigolfInputHint[EMinigolfInputHint["StartGame"] = 3] = "StartGame";
    EMinigolfInputHint[EMinigolfInputHint["ResetGame"] = 4] = "ResetGame";
    EMinigolfInputHint[EMinigolfInputHint["GoToLobby"] = 5] = "GoToLobby";
    EMinigolfInputHint[EMinigolfInputHint["ChangeSettings"] = 6] = "ChangeSettings";
})(EMinigolfInputHint = exports.EMinigolfInputHint || (exports.EMinigolfInputHint = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Crokinole_Input;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.hint);
    messageWriter_sidecar_1.messageWriter.write32(m, d.frame);
    messageWriter_sidecar_1.messageWriter.write32(m, d.targetId);
    if (d.hint === EMinigolfInputHint.FlingDisc ||
        d.hint === EMinigolfInputHint.PlaceDisc) {
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.wx);
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.wy);
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.fx);
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.fy);
        messageWriter_sidecar_1.messageWriter.writeFloat(m, d.angle);
    }
    if (d.hint === EMinigolfInputHint.PlaceDisc) {
        messageWriter_sidecar_1.messageWriter.write32(m, d.playerNum);
    }
    if (d.hint === EMinigolfInputHint.ChangeSettings) {
        messageWriter_sidecar_1.messageWriter.writeString(m, d.settingName);
        messageWriter_sidecar_1.messageWriter.writeString(m, d.settingValue);
    }
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        hint: messageWriter_sidecar_1.messageWriter.read8(m),
        frame: messageWriter_sidecar_1.messageWriter.read32(m),
        targetId: messageWriter_sidecar_1.messageWriter.read32(m),
        wx: 0,
        wy: 0,
        fx: 0,
        fy: 0,
        angle: 0,
        playerNum: 0,
        settingName: '',
        settingValue: '',
    };
    if (d.hint === EMinigolfInputHint.FlingDisc ||
        d.hint === EMinigolfInputHint.PlaceDisc) {
        d.wx = messageWriter_sidecar_1.messageWriter.readFloat(m);
        d.wy = messageWriter_sidecar_1.messageWriter.readFloat(m);
        d.fx = messageWriter_sidecar_1.messageWriter.readFloat(m);
        d.fy = messageWriter_sidecar_1.messageWriter.readFloat(m);
        d.angle = messageWriter_sidecar_1.messageWriter.readFloat(m);
    }
    if (d.hint === EMinigolfInputHint.PlaceDisc) {
        d.playerNum = messageWriter_sidecar_1.messageWriter.read32(m);
    }
    if (d.hint === EMinigolfInputHint.ChangeSettings) {
        d.settingName = messageWriter_sidecar_1.messageWriter.readString(m);
        d.settingValue = messageWriter_sidecar_1.messageWriter.readString(m);
    }
    return d;
}
exports.read = read;
function test() {
    var ex = create({
        hint: EMinigolfInputHint.GoToLobby,
        frame: 120,
    });
    messageWriter_sidecar_1.messageWriter.test('mouseInput 1', ex, write, read);
    ex = create({
        hint: EMinigolfInputHint.FlingDisc,
        frame: 121,
        wx: 123.45,
        //wy: 456.78,
        wy: 456789.456789,
        fx: 999.999,
        fy: 888.888,
        //wy: 12323423.2342342,
        angle: -45.556,
        targetId: 123,
    });
    messageWriter_sidecar_1.messageWriter.test('mouseInput FlingDisc', ex, write, read);
    ex = create({
        hint: EMinigolfInputHint.ChangeSettings,
        frame: 122,
        settingName: 'asdf',
        settingValue: '123',
    });
    messageWriter_sidecar_1.messageWriter.test('mouseInput ChangeSettings', ex, write, read);
    ex = create({
        hint: EMinigolfInputHint.PlaceDisc,
        frame: 121,
        wx: 123.45,
        wy: 456.78,
        angle: -45.556,
        targetId: 123,
        playerNum: 2,
    });
    messageWriter_sidecar_1.messageWriter.test('mouseInput PlaceDisc', ex, write, read);
}
exports.test = test;
// export function process(
//   m: IMessageWriter,
//   isFromHost: boolean,
//   fromId: number,
// ) {
//   let msg = read(m)
//   console.log(namespace, 'process', msg.hint, msg.frame)
//   if (msg.frame <= 0) {
//     // Requesting to calculate frame
//     if (getIsHost()) {
//       // TODO: any more validation of message?
//       // TODO: better way to do this?
//       if (crokinoleSimulationManager.isPlayerOnCorrectGameSync(fromId)) {
//         let updatedMsg = Object.assign({}, msg, {
//           frame: crokinoleSimulationManager.get().nextMessageSimulationFrame,
//         })
//         // console.log('mouseInput', 'updating msg', updatedMsg)
//         forwardToAll(updatedMsg)
//       } else {
//         console.error(namespace, 'rejecting message, out of sync')
//       }
//     } else {
//       console.error(namespace, 'rejecting message, not host')
//     }
//   } else {
//     // Add to our frame stack
//     crokinoleSimulationManager.addMessageToBuffer(msg)
//   }
// }
function create(msg) {
    var _default = {
        hint: EMinigolfInputHint.Null,
        targetId: 0,
        frame: 0,
        playerNum: 0,
        wx: 0,
        wy: 0,
        fx: 0,
        fy: 0,
        angle: 0,
        settingName: '',
        settingValue: '',
    };
    var combinedMsg = Object.assign({}, _default, msg);
    return combinedMsg;
}
exports.create = create;
function requestHost(msg) {
    console.log(namespace, 'requestHost', msg.hint, msg.frame);
    var combinedMsg = create(msg);
    minigolf_bufferedCommands_sidecar_1.minigolf_bufferedCommands.addInputMessageToBuffer(combinedMsg);
    // TODO: restore websocket
    // websockets._sendMessageToHost(write, combinedMsg, true)
}
exports.requestHost = requestHost;
function forwardToAll(msg) {
    console.log(namespace, 'forwardToAll', msg.hint, msg.frame);
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true);
}
exports.forwardToAll = forwardToAll;
function execute(msg) {
    console.log(namespace, 'execute', msg.hint);
    // if (msg.hint === EMinigolfInputHint.PlaceDisc) {
    //   _execute_placeDisc(msg)
    //   return
    // }
    if (msg.hint === EMinigolfInputHint.FlingDisc) {
        _execute_flingDisc(msg);
        return;
    }
    console.warn(namespace, 'execute', 'unknown hint', msg.hint);
}
exports.execute = execute;
// export function _execute_placeDisc(msg: IMinigolfMessage_input) {
//   let player = crokinoleGameState.getPlayer(msg.playerNum)
//   if (player.numTokensLeft >= 0) {
//     // TODO: more checks for valid state?
//     player.numTokensLeft--
//     let newPuck = crokinolePucks.create(msg.wx, msg.wy, player)
//     crokinoleGameState.get().currentPuck = newPuck
//     crokinoleGameState.advanceState()
//   }
// }
function _execute_flingDisc(msg) {
    console.log(namespace, '_execute_flingDisc', msg.hint);
    var currentPuck = minigolfCreatures_sidecar_1.minigolfCreatures.getById(msg.targetId);
    if (!currentPuck) {
        assert_sidecar_1.assert.warn('puck not found', msg.targetId);
        return;
    }
    console.log(namespace, '_execute_flingDisc', 'applying impulse');
    currentPuck.rigidBody.applyImpulseAtPoint({
        x: msg.fx,
        y: msg.fy,
    }, {
        x: msg.wx,
        y: msg.wy,
    }, true);
    minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_flung();
    // puck1.applyTorqueImpulse(0.01, true)
    // console.log('flicked', 'advanceState', crokinoleGameState.get().state)
    // crokinoleGameState.advanceState()
    // console.log('flicked', 'advanceState2', crokinoleGameState.get().state)
}
exports._execute_flingDisc = _execute_flingDisc;
